import type { OwaDate } from 'owa-datetime';
import { addDays, differenceInMilliseconds, startOfDay } from 'owa-datetime';
import isDSTTransitionDate from './isDSTTransitionDate';
import TimeConstants from './TimeConstants';

/**
 * Gets the actual number of milliseconds in a day, accounting for DST transitions.
 *
 * During DST transitions:
 * - Spring forward: Returns 82,800,000 milliseconds (23 hours) when an hour is skipped
 * - Fall back: Returns 90,000,000 milliseconds (25 hours) when an hour is repeated
 * - Normal days: Returns 86,400,000 milliseconds (24 hours)
 *
 * @param date The date to check
 * @returns The actual number of milliseconds in that calendar day
 */
export default function getMillisecondsInDay(date: OwaDate): number {
    if (!isDSTTransitionDate(date)) {
        return TimeConstants.MillisecondsInOneDay;
    }

    // DST-aware: difference between start of day and next day
    return differenceInMilliseconds(addDays(startOfDay(date), 1), startOfDay(date));
}
